import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Img,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TextField from 'components/fields/TextField';

import Level from 'assets/img/games/new-level-final.png';

import Badges from 'assets/img/games/badges-game-read-format.png';

interface DialogFormProps {
  handleShowComponent: (componentName: string) => void;
}

const DialogForm: React.FC<DialogFormProps> = ({ handleShowComponent }) => {
  const [img, setImg] = useState([Level, Badges]);
  const [number, setNumber] = useState<any>([]);

  const navigate = useNavigate();

  const [input, setInput] = useState<any>({ dialog: '', imgId: '' });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInput((prev: any) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleClickImg = (id: any) => {
    setInput((prev: any) => {
      return { ...prev, imgId: id };
    });
  };

  return (
    <>
      <Box mt={{ base: '0px', xl: '00px' }}>
        {/* <Card mb={{ base: '0px', xl: '20px', sm: '20px' }}> */}
        <Grid templateColumns="repeat(2, 1fr)" gap={6}>
          <GridItem w="100%">
            <TextField
              mb="0px"
              me="30px"
              w="100%"
              id="dialog"
              label="Dialog*"
              placeholder="eg. Game"
              name="dialog"
              onChange={handleChange}
              value={input.dialog}
            />
          </GridItem>
          <GridItem w="100%">
            <Text fontSize={14} fontWeight={600} mb={'10px'}>
              Pose NON Player
            </Text>
            <Grid templateColumns="repeat(5, 1fr)" gap={4}>
              {img.map((img, i) => (
                <GridItem w="100%">
                  <Img
                    src={img}
                    data-name="imgId"
                    onClick={() => handleClickImg(i)}
                    h="75px"
                    w="75px"
                    borderRadius="50px"
                    boxShadow="1px 3px 17px #332f2f4d"
                  />
                </GridItem>
              ))}
            </Grid>
          </GridItem>
        </Grid>

        <Button
          bg={'#3311db'}
          _hover={{ bg: '#3311db' }}
          color={'#fff'}
          mt={'20px'}
        >
          Save
        </Button>
      </Box>
    </>
  );
};

export default DialogForm;
